export default __webpack_public_path__ + "styles/icons/1000mLBeaker.svg";